import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-modal-recusar-usuario',
    templateUrl: './modal-validar-usuario.page.html',
    styleUrls: ['./modal-validar-usuario.page.scss']
})
export class ModalValidarUsuarioPage {

    motivo = '';

    constructor(
        private modalController: ModalController,
        private toastService: ToastService
    ) {
    }

    async dismiss() {
        await this.modalController.dismiss();
    }

    async validar() {

        if (this.motivo.trim().length === 0) {
            this.toastService.toastWarning('Preencha o motivo');
            return;
        }

        await this.modalController.dismiss(this.motivo);
    }

}
